// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import AddressAutocompleteController from './address_autocomplete_controller';
application.register('address-autocomplete', AddressAutocompleteController);

import ServiceSelectionController from './service_selection_controller';
application.register('service-selection', ServiceSelectionController);

import ServiceToggleController from './service_toggle_controller';
application.register('service-toggle', ServiceToggleController);

import StripeCheckoutController from './stripe_checkout_controller';
application.register('stripe-checkout', StripeCheckoutController);

import MapboxMapController from './mapbox_map_controller';
application.register('mapbox-map', MapboxMapController);

import PricingToggleController from './pricing_toggle_controller';
application.register('pricing-toggle', PricingToggleController);

import SortableController from './sortable_controller';
application.register('sortable', SortableController);

import PoolDetectionController from './pool_detection_controller';
application.register('pool-detection', PoolDetectionController);

import StaticMapController from './static_map_controller';
application.register('static-map', StaticMapController);

import DropdownController from './dropdown_controller';
application.register('dropdown', DropdownController);

import CheckoutFormController from './checkout_form_controller';
application.register('checkout-form', CheckoutFormController);

import ManualOrderController from './manual_order_controller';
application.register('manual-order', ManualOrderController);

import QuotePaymentController from './quote_payment_controller';
application.register('quote-payment', QuotePaymentController);

import SqftPricingController from './sqft_pricing_controller';
application.register('sqft-pricing', SqftPricingController);

import ThumbnailPickerController from './thumbnail_picker_controller';
application.register('thumbnail-picker', ThumbnailPickerController);

import DirectUploadController from './direct_upload_controller';
application.register('direct-upload', DirectUploadController);

import ZoneTypeToggleController from './zone_type_toggle_controller';
application.register('zone-type-toggle', ZoneTypeToggleController);

import PricingZoneMapController from './pricing_zone_map_controller';
application.register('pricing-zone-map', PricingZoneMapController);

import ZipCodeMapController from './zip_code_map_controller';
application.register('zip-code-map', ZipCodeMapController);

import FormController from './form_controller';
application.register('form', FormController);

import RadioCardController from './radio_card_controller';
application.register('radio-card', RadioCardController);

import ScheduleKanbanController from './schedule_kanban_controller';
application.register('schedule-kanban', ScheduleKanbanController);

import SidebarController from './sidebar_controller';
application.register('sidebar', SidebarController);

import PhoneFormatController from './phone_format_controller';
application.register('phone-format', PhoneFormatController);

import DiscountTypeToggleController from './discount_type_toggle_controller';
application.register('discount-type-toggle', DiscountTypeToggleController);

import PriceInputController from './price_input_controller';
application.register('price-input', PriceInputController);

import ManualPoolEntryController from './manual_pool_entry_controller';
application.register('manual-pool-entry', ManualPoolEntryController);

import PhotoUploadController from './photo_upload_controller';
application.register('photo-upload', PhotoUploadController);

import QuoteRequestToggleController from './quote_request_toggle_controller';
application.register('quote-request-toggle', QuoteRequestToggleController);

import ExitIntentController from './exit_intent_controller';
application.register('exit-intent', ExitIntentController);

import SignaturePadController from './signature_pad_controller';
application.register('signature-pad', SignaturePadController);

import AgreementGeneratorController from './agreement_generator_controller';
application.register('agreement-generator', AgreementGeneratorController);

import CheckboxToggleController from './checkbox_toggle_controller';
application.register('checkbox-toggle', CheckboxToggleController);

import CheckoutFlowController from './checkout_flow_controller';
application.register('checkout-flow', CheckoutFlowController);

import ModalController from './modal_controller';
application.register('modal', ModalController);

import ToastController from './toast_controller';
application.register('toast', ToastController);

import PrintController from './print_controller';
application.register('print', PrintController);

import ClipboardController from './clipboard_controller';
application.register('clipboard', ClipboardController);

import FormSubmitController from './form_submit_controller';
application.register('form-submit', FormSubmitController);

import NavigateController from './navigate_controller';
application.register('navigate', NavigateController);

import PrefillController from './prefill_controller';
application.register('prefill', PrefillController);

import OffcanvasController from './offcanvas_controller';
application.register('offcanvas', OffcanvasController);

import ExpandableTextController from './expandable_text_controller';
application.register('expandable-text', ExpandableTextController);

import ServicePreviewController from './service_preview_controller';
application.register('service-preview', ServicePreviewController);

import ColorSyncController from './color_sync_controller';
application.register('color-sync', ColorSyncController);

import ModalOpenerController from './modal_opener_controller';
application.register('modal-opener', ModalOpenerController);

import DemoCheckoutController from './demo_checkout_controller';
application.register('demo-checkout', DemoCheckoutController);

import SettingsAddressController from './settings_address_controller';
application.register('settings-address', SettingsAddressController);

import MobileMenuController from './mobile_menu_controller';
application.register('mobile-menu', MobileMenuController);

import ScrollNavController from './scroll_nav_controller';
application.register('scroll-nav', ScrollNavController);

import SlugPreviewController from './slug_preview_controller';
application.register('slug-preview', SlugPreviewController);

import StarRatingController from './star_rating_controller';
application.register('star-rating', StarRatingController);

import ScrollAnimateController from './scroll_animate_controller';
application.register('scroll-animate', ScrollAnimateController);

import BrandingPreviewController from './branding_preview_controller';
application.register('branding-preview', BrandingPreviewController);

import RevenueCalculatorController from './revenue_calculator_controller';
application.register('revenue-calculator', RevenueCalculatorController);

import FabController from './fab_controller';
application.register('fab', FabController);

import PoolQuickSelectController from './pool_quick_select_controller';
application.register('pool-quick-select', PoolQuickSelectController);

import BillingOptionsController from './billing_options_controller';
application.register('billing-options', BillingOptionsController);

import ServiceIntervalController from './service_interval_controller';
application.register('service-interval', ServiceIntervalController);

import VisibilitySwitchController from './visibility_switch_controller';
application.register('visibility-switch', VisibilitySwitchController);

import RoiCalculatorController from './roi_calculator_controller';
application.register('roi-calculator', RoiCalculatorController);

import AiDescriptionController from './ai_description_controller';
application.register('ai-description', AiDescriptionController);

import VoiceInputController from './voice_input_controller';
application.register('voice-input', VoiceInputController);

import DocsSearchController from './docs_search_controller';
application.register('docs-search', DocsSearchController);

import ObfuscateEmailController from './obfuscate_email_controller';
application.register('obfuscate-email', ObfuscateEmailController);

import AddonSlideoverController from './addon_slideover_controller';
application.register('addon-slideover', AddonSlideoverController);

import AddonFormController from './addon_form_controller';
application.register('addon-form', AddonFormController);

import LandingCalculatorController from './landing_calculator_controller';
application.register('landing-calculator', LandingCalculatorController);

import DebounceController from './debounce_controller';
application.register('debounce', DebounceController);

import CopyLinksController from './copy_links_controller';
application.register('copy-links', CopyLinksController);

import './railsui';
